import { render, staticRenderFns } from "./u-tabs.vue?vue&type=template&id=0de61367&scoped=true&"
import script from "./u-tabs.vue?vue&type=script&lang=js&"
export * from "./u-tabs.vue?vue&type=script&lang=js&"
import style0 from "./u-tabs.vue?vue&type=style&index=0&id=0de61367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de61367",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-tabs/u-tabs.vue"
export default component.exports